export enum HttpStatus {
  Success = 200,
  NoContent = 204,
  Failed = 400,
  Error = 300,
  Unauthorized = 401,
  NotFound = 404,
  Conflict  = 409
}